module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c6512c99c2c300e1ed16dfc63d514d17.png";